import { tns } from "../../node_modules/tiny-slider/src/tiny-slider"

// Generic slider
const elements = document.querySelectorAll('.m-slider');
if (elements.length > 0) {
  for(const element of elements) {
    tns({
      container: element,
      gutter: 16,
      nav: false,
      responsive: {
        640: {
          items: 2
        },
        1024: {
          items: 3
        }
      }
    });
  }
}

// Slider for images
const elementsImages = document.querySelectorAll('.m-sliderFull');
if (elementsImages.length > 0) {
  for(const element of elementsImages) {
    const slides = element.querySelectorAll('.m-image');
    if( slides.length > 1 ) {
      tns({
        container: element,
        items: 1,
        nav: true,
        slideBy: "page",
        lazyload: true
      });
    }
  }
}

// Slider for content
const elementsContent = document.querySelectorAll('.n-content.--slider');
if (elementsContent.length > 0) {
  for(const element of elementsContent) {
    tns({
      container: element.querySelector('.content'),
      items: 3,
      slideBy: 'page',
    });
  }
}

// Slider for maintenance
const elementsMaintenance = document.querySelectorAll('.maintenance-page .media');
if (elementsMaintenance.length > 0) {
  tns({
    container: element,
    items: 1,
    controls: false,
    autoplay: true,
    autoplayButtonOutput: false,
    autoplayTimeout: 4000,
    speed: 600,
    mode: "gallery"
  });
}

// Slider for products (home)
const slidersProducts = document.querySelectorAll('.slider-products');
if (slidersProducts.length > 0) {
  for(const sliderProduct of slidersProducts) {
    const nav = sliderProduct.parentElement.querySelector('nav')
    const slides = sliderProduct.querySelectorAll('.slide')
    for( const slide of slides ) {
      const link = document.createElement('A')
      link.innerHTML = slide.dataset.title
      nav.appendChild(link)
    }
    tns({
      container: sliderProduct,
      items: 1,
      mouseDrag: true,
      controls: false,
      navContainer: nav,
    });
  }
}
